import { Segmented } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import Router from "../..";
import test_img from "../../../images/32637972_7843794.jpg";
import { parseApiAmount } from "../../utils/amountFormat";
import { CATEGORY_MAPPING, CATEGORY_STYLES } from "../../utils/categories";
import { getContentFormatOptions } from "../../utils/contentFormat";

export const CampaignDetailInfo = ({
  selectedCampaign,
  tiktokVideos,
  instagramContents,
  youtubeVideos,
}) => {
  const [selectedView, setSelectedView] = useState("campaign-info");
  const brandSocialContents = {
    tiktok: selectedCampaign?.recent_tiktok_videos ?? tiktokVideos ?? [],
    instagram:
      selectedCampaign?.recent_instagram_contents ?? instagramContents ?? [],
    youtube: selectedCampaign?.recent_youtube_videos ?? youtubeVideos ?? [],
  };

  const contentFormatOptions = getContentFormatOptions(
    selectedCampaign.content_format
  );
  const payoutAmount =
    typeof selectedCampaign.payout === "object"
      ? parseApiAmount(selectedCampaign.payout)
      : Number(selectedCampaign.payout);

  const brandName = selectedCampaign?.sign?.company_name;

  return (
    <div>
      <div className="mb-5">
        <img
          src={selectedCampaign.thumbnail || test_img}
          alt=""
          className="w-full h-[200px] object-cover rounded-lg"
        />
      </div>
      <div className="mb-4">
        <span
          className="font-medium px-[12px] py-[4px] rounded-[4px] text-[14px]"
          style={
            CATEGORY_STYLES[selectedCampaign.campaign_category] ||
            CATEGORY_STYLES.etc
          }
        >
          {CATEGORY_MAPPING[selectedCampaign.campaign_category] || "기타"}
        </span>
      </div>
      <div className="text-[14px] text-[#666] font-semibold mb-1">
        {selectedCampaign.company_name}
      </div>
      <h2 className="text-[21px] font-bold mb-8">{selectedCampaign.title}</h2>

      <div className="mb-6">
        <Segmented
          value={selectedView}
          onChange={setSelectedView}
          options={[
            { label: "캠페인 정보", value: "campaign-info" },
            { label: "브랜드 콘텐츠", value: "brand-videos" },
          ]}
        />
      </div>

      {selectedView === "campaign-info" ? (
        <section>
          <div className="font-medium mb-5">캠페인 기본 정보</div>
          <div className="grid grid-cols-2 gap-4 bg-[#f9f9f9] p-5 rounded-lg mb-5">
            {selectedCampaign.content_format && (
              <div className="col-span-2 flex flex-col">
                <strong>콘텐츠 형식</strong>
                <div className="mt-1 flex flex-wrap gap-2">
                  {contentFormatOptions.map((option) => {
                    const Icon = option.Icon;

                    return (
                      <span
                        key={option.value}
                        className="inline-flex items-center gap-1 rounded-full text-[14px] text-[#414141] px-4 py-1 bg-[#ffffff] border"
                      >
                        {Icon ? (
                          <Icon
                            className={`text-[18px] shrink-0 ${
                              option.iconClassName ?? ""
                            }`}
                            aria-hidden
                          />
                        ) : null}
                        {option.label}
                      </span>
                    );
                  })}
                </div>
              </div>
            )}
            <div>
              <strong>모집인원</strong>
              <div>{selectedCampaign.recruit_count}명</div>
            </div>

            {selectedCampaign.seeding_type === "paid" && (
              <div>
                <strong>리워드</strong>
                <div>
                  {payoutAmount.toLocaleString()} {selectedCampaign.currency}
                </div>
              </div>
            )}
            <div>
              <strong>시딩 타입</strong>
              <div>
                {selectedCampaign.seeding_type === "free" ? "무가" : "유가"}
              </div>
            </div>
            <div>
              <strong>2차 활용 여부</strong>
              <div>
                {selectedCampaign.allow_secondary_use === 1
                  ? "활용함"
                  : "활용 안 함"}
              </div>
            </div>
            <div>
              <strong>모집기간</strong>
              <div className="flex flex-wrap items-center gap-1">
                <span>
                  {selectedCampaign.start_at
                    ? dayjs(selectedCampaign.start_at).format("YYYY.MM.DD")
                    : "-"}
                </span>

                <span className="text-gray-400">~</span>

                <span>
                  {selectedCampaign.end_at
                    ? dayjs(selectedCampaign.end_at).format("YYYY.MM.DD")
                    : "-"}
                </span>
              </div>
            </div>
          </div>
          {selectedCampaign.product_info && (
            <>
              <div className="font-medium mb-5">제공 제품</div>
              <div className="bg-[#f9f9f9] p-5 rounded-lg mb-5">
                <p className="whitespace-pre-line">
                  {selectedCampaign.product_info}
                </p>
              </div>
            </>
          )}
          <div className="font-medium mb-5">캠페인 소개</div>
          <div className="bg-[#f9f9f9] p-5 rounded-lg mb-5">
            <p className="whitespace-pre-line">
              {selectedCampaign.description}
            </p>
          </div>
          <Router.MissionDisplay mission={selectedCampaign.mission} />
          {selectedCampaign.attachment_url && (
            <div className="mb-5">
              <img
                src={selectedCampaign.attachment_url}
                alt="캠페인 상세 설명 사진"
                className="w-full h-auto object-contain rounded-lg"
              />
            </div>
          )}
        </section>
      ) : (
        <section className="space-y-6">
          <div className="mb-2 flex items-end justify-between">
            <div>
              <p className="text-[16px] font-bold tracking-tight text-[#111827]">
                브랜드 최근 영상
              </p>

              <p className="mt-1 text-[13px] leading-relaxed text-[#6b7280]">
                브랜드의 최근 영상 톤과 분위기를 빠르게 확인해보세요.
              </p>
            </div>
          </div>
          <Router.BrandSocialContents
            brandName={brandName}
            contents={brandSocialContents}
          />
          {/* {brandName !== "금바다" && videos.length > 0 ? (
            <>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {videos.map((video) => (
                  <div
                    key={video.video_id}
                    className="group overflow-hidden rounded-[24px] border border-[#ebeff5] text-left shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(15,23,42,0.12)]"
                    onMouseEnter={() => handleVideoMouseEnter(video)}
                    onMouseLeave={() => handleVideoMouseLeave(video.video_id)}
                    onClick={() => handleOpenVideo(video.video)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleOpenVideo(video.video);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="relative aspect-[3/4] overflow-hidden">
                      <img
                        src={video.thumbnail || test_img}
                        alt="브랜드 영상 썸네일"
                        className={`absolute inset-0 scale-[1.01] h-full w-full object-cover transition-all duration-300 ${
                          hoveredVideoId === video.video_id
                            ? "scale-[1.03] opacity-0"
                            : "scale-100 opacity-100"
                        }`}
                        onError={(e) => {
                          e.currentTarget.src = test_img;
                        }}
                      />
                      {video.video ? (
                        <video
                          ref={(element) => {
                            if (element) {
                              videoRefs.current[video.video_id] = element;
                            }
                          }}
                          src={video.video}
                          poster={video.thumbnail || test_img}
                          className={`absolute inset-0 scale-[1.01] h-full w-full object-cover rounded-[inherit] will-change-transform transition-opacity duration-300 ${
                            hoveredVideoId === video.video_id
                              ? "opacity-100"
                              : "opacity-0"
                          }`}
                          muted={isMuted}
                          loop
                          playsInline
                          preload="metadata"
                        />
                      ) : null}
                      {hoveredVideoId === video.video_id && video.video ? (
                        <button
                          type="button"
                          className="absolute right-3 top-3 z-10 inline-flex h-9 w-9 md:h-7 md:w-7 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur-sm transition hover:bg-black/70"
                          onClick={(e) => handleToggleMute(e, video.video_id)}
                          aria-label={isMuted ? "소리 켜기" : "소리 끄기"}
                        >
                          {isMuted ? (
                            <IoVolumeMuteSharp className="text-[16px] md:text-[12px]" />
                          ) : (
                            <IoVolumeMediumSharp className="text-[16px] md:text-[12px]" />
                          )}
                        </button>
                      ) : null}
                    </div>
                    <div className="text-[14px] md:text-[12px] text-[#595959] space-y-1 p-4">
                      <p className="flex items-center gap-1.5 m-0 truncate">
                        <IoPlay className="text-[#13C2C2]" />
                        <span>{formatCnt(video.play_count || 0)}</span>
                      </p>
                      <p className="flex items-center gap-1.5 m-0 truncate">
                        <IoHeartSharp className="text-[#FF4D4F]" />
                        <span>{formatCnt(video.like_count || 0)}</span>
                      </p>
                      <p className="flex items-center gap-1.5 m-0 truncate">
                        <IoChatbubbleEllipses className="text-[#1890FF]" />
                        <span>{formatCnt(video.comment_count || 0)}</span>
                      </p>
                      <p className="flex items-center gap-1.5 m-0 truncate">
                        <IoShareSocialSharp className="text-[#52C41A]" />
                        <span>{formatCnt(video.share_count || 0)}</span>
                      </p>
                      <p className="flex items-center gap-1.5 m-0 truncate">
                        <IoBookmark className="text-[#FAAD14]" />
                        <span>{formatCnt(video.collect_count || 0)}</span>
                      </p>
                      <p className="text-[14px] md:text-[12px] mt-[6px] md:mt-[8px] mb-0 text-[#1890FF] overflow-hidden text-ellipsis whitespace-nowrap font-medium min-h-[16px] md:min-h-[20px]">
                        {getDisplayHashtags(video.hashtag_name)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Empty
              description={
                <div className="text-[14px] text-[#666]">
                  브랜드 영상이 없습니다.
                </div>
              }
            />
          )} */}
        </section>
      )}
    </div>
  );
};
